import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import Head from "@/components/Head/index.vue";
import Tabs from "@/components/Tabs/index.vue";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import Pagination from "@/components/Pagination/index.vue";
import { defineComponent, onActivated, onMounted, reactive, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { ElMessage, ElMessageBox } from "element-plus";
import 'element-plus/es/components/message/style/index'
import 'element-plus/es/components/message-box/style/index'
 //import { useStore } from "vuex";

export default defineComponent({
  name: "Email",
  components: {
    Head: Head,
    Tabs: Tabs,
    Pagination: Pagination
  },
  setup: function setup() {
    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var keepStatus = true; //首次进入为缓存状态，但不需要走activited方法
    //let store = useStore();
    //let user =store.state.user.user.userId//获取用户id

    var tableloading = globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$tipsText.$tips_tableloading;
    var router = useRouter();
    var titles = ["全部", "建议", "咨询", "投诉"];
    var Data = reactive({
      titleArr: ["未回复信件", "已回复信件"],
      tabsIndex: 0,
      isactive: 0,
      // 列表请求参数
      listParams: {
        pageIndex: 1,
        pageSize: 10,
        mailboxStatus: 0,
        typeId: null
      },
      listData: [],
      total: 0,
      person: false
    });
    var isactive = ref(0);
    onMounted(function () {
      getTableOne();
      getshuji();
    });
    onActivated(function () {
      if (!keepStatus) {
        getTableOne();
      } else {
        keepStatus = false;
      }
    }); //获取书记id

    var getshuji = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$globalProperti, code;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["isSecretary"]();

              case 2:
                _yield$globalProperti = _context.sent;
                code = _yield$globalProperti.code;

                if (code == 0) {
                  Data.person = true;
                } else {
                  Data.person = false;
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getshuji() {
        return _ref.apply(this, arguments);
      };
    }(); // 第一个table的初始化


    var getTableOne = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["emailList"](Data.listParams);

              case 2:
                res = _context2.sent;
                Data.listData = res.data;

                if (Data.listParams.mailboxStatus == 0) {
                  Data.total = res.total;
                }

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function getTableOne() {
        return _ref2.apply(this, arguments);
      };
    }(); // 获取Tab索引值


    var tabsChange = function tabsChange(val) {
      Data.listParams.mailboxStatus = val;
    }; // 获取类型


    var titlechange = function titlechange(val) {
      isactive.value = val;

      if (val !== 0) {
        Data.listParams.typeId = val;
      } else {
        Data.listParams.typeId = null;
      }
    }; // 获取分页返回值：点击的第n页


    var changPage = function changPage(val) {
      Data.listParams.pageIndex = val;
    }; //颜色


    var tableRowClassName = function tableRowClassName(_ref3) {
      var row = _ref3.row;

      if (row.delFlag === 1) {
        return "warning-row";
      } else if (row.delFlag === 0) {
        return "success-row";
      }

      return "";
    }; //删除


    function removeEmail(_x) {
      return _removeEmail.apply(this, arguments);
    } // 监听tabs索引值改变、pager分页改变


    function _removeEmail() {
      _removeEmail = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(mailboxId) {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                //TODO可优化进行提示
                ElMessageBox.confirm("确定要删除?", "温馨提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning"
                }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                  var _yield$globalProperti2, code, msg;

                  return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          _context4.next = 2;
                          return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["delEmail"](mailboxId);

                        case 2:
                          _yield$globalProperti2 = _context4.sent;
                          code = _yield$globalProperti2.code;
                          msg = _yield$globalProperti2.msg;

                          if (code == 0) {
                            ElMessage.success("删除成功");
                            getTableOne();
                          } else {
                            ElMessage.error(msg);
                          }

                        case 6:
                        case "end":
                          return _context4.stop();
                      }
                    }
                  }, _callee4);
                }))).catch(function () {//console.log(111);
                });

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));
      return _removeEmail.apply(this, arguments);
    }

    watch(function () {
      return [Data.listParams.pageIndex, Data.listParams.mailboxStatus, Data.listParams.typeId];
    }, function () {
      getTableOne();
    });
    var route = useRoute(); // watch(
    //   () => route.query,
    //   (v1) => {
    //     console.log(v1.userId==undefined);
    //   //  if(v1.userId==undefined){getTableOne();}
    //   }
    // );
    //我要写信

    var editEmail = function editEmail(mailboxId) {
      router.push({
        name: "letter",
        query: {
          mailboxId: mailboxId
        }
      });
    }; // 查看详情


    var getDetail = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(mailboxId, userId) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                router.push({
                  name: "emailDetail",
                  query: {
                    mailboxId: mailboxId,
                    userId: userId
                  }
                }); //修改状态

                if (!(Data.person == true)) {
                  _context3.next = 4;
                  break;
                }

                _context3.next = 4;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["emailStatus"](mailboxId);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function getDetail(_x2, _x3) {
        return _ref4.apply(this, arguments);
      };
    }(); //我要写信


    var getLetter = function getLetter() {
      router.push({
        name: "letter",
        query: {
          userId: 0
        }
      });
    };

    return {
      titlechange: titlechange,
      Data: Data,
      titles: titles,
      isactive: isactive,
      router: router,
      route: route,
      tabsChange: tabsChange,
      changPage: changPage,
      getDetail: getDetail,
      getLetter: getLetter,
      editEmail: editEmail,
      removeEmail: removeEmail,
      getshuji: getshuji,
      tableloading: tableloading,
      tableRowClassName: tableRowClassName
    };
  }
});